import React from 'react'

import { FieldArray } from 'formik'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import {
    formataDataEmMesAnoSemBarra,
} from '../../../business-components/Date/Date'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem2xs4,
    GridItem3xs4,
    GridItem3xs5,
    GridItem3xs6,
    GridItem6,
    GridItem11,
} from '../../../business-components/Grid/Grid'

import {
    TextValidatorValor,
    TextValidatorNumber,
    TextValidatorNumberRequired,
    TextValidatorMesAnoRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    IconButtonClearEntradaDados,
    IconButtonMaisInformacoes,
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

//import {
//    CustomizedDialogsPopupFundosPrevidenciaPrivada
//} from './PrevidenciaPrivadaComp'

import tipoPeriodicidadeList from '../../../business-rules/List/tipoPeriodicidadeList'

import tipoMomentoTributacaoIRList from '../../../business-rules/List/tipoMomentoTributacaoIRList'



const SimulacaoAporteTipoMomentoTributacaoIR = ({ handleChange, report, indAporte, item, ind }) => {

    return (
        <>
            <GridItem3xs6>
                <TextFieldTextSelect
                    name={`objPrevidenciaPrivada.simulacao[${indAporte}].aporte[${ind}].tipoMomentoTributacaoIR`}
                    label={LABEL.tipoMomentoTributacaoIR}
                    value={item.tipoMomentoTributacaoIR || ''}
                    onChange={handleChange}
                    list={tipoMomentoTributacaoIRList}
                    disabled={report}
                    report={report}
                />
            </GridItem3xs6>

            {(item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRComeCotas ||
            item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRPGBL ||
            item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRVGBL ||
            item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRResgate) && (
                <GridItem2xs4>
                    <TextValidatorNumberRequired
                        name={`objPrevidenciaPrivada.simulacao[${indAporte}].aporte[${ind}].percIR`}
                        label={LABEL.percIR}
                        value={item.percIR === 0 ? 0 : item.percIR || ''}
                        onChange={handleChange}
                        numMin={NUMMIN.percIR}
                        numMax={NUMMAX.percIR}
                        disabled={report}
                        report={report}
                    />
                </GridItem2xs4>
            )}

            {(item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRVGBL ||
            item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRResgate) && (
                <GridItem3xs5>
                    <TextValidatorNumberRequired
                        name={`objPrevidenciaPrivada.simulacao[${indAporte}].aporte[${ind}].tempoMinimoEntreAportesResgatesCalculoIRAnos`}
                        label={LABEL.tempoMinimoEntreAportesResgatesCalculoIRAnos}
                        value={
                            item.tempoMinimoEntreAportesResgatesCalculoIRAnos === 0
                                ?
                                    0
                                :
                                    item.tempoMinimoEntreAportesResgatesCalculoIRAnos || ''
                        }
                        onChange={handleChange}
                        numMin={NUMMIN.tempoMinimoEntreAportesResgatesCalculoIRAnos}
                        numMax={NUMMAX.tempoMinimoEntreAportesResgatesCalculoIRAnos}
                        disabled={report}
                        report={report}
                    />
                </GridItem3xs5>
            )}
        </>
    )
}
const SimulacaoAporteTaxaTipoMomentoTributacaoIR = ({ values, handleChange, report, indAporte, item, ind, popup }) => {

    return (
        <>
            <GridContainer>
                <GridItem2/>

                <GridItem2xs4>
                    <TextValidatorNumber
                        name={`objPrevidenciaPrivada.simulacao[${indAporte}].aporte[${ind}].taxaJurosAnual`}
                        label={LABEL.taxaJurosAnual}
                        value={item.taxaJurosAnual === 0 ? 0 : item.taxaJurosAnual || ''}
                        onChange={handleChange}
                        numMin={NUMMIN.taxaNegativa}
                        numMax={NUMMAX.taxa}
                        disabled={report}
                        report={report}
                    />
                </GridItem2xs4>

                {popup
                    ?
                        <GridItem3xs6>
                            {/*
                            <CustomizedDialogsPopupFundosPrevidenciaPrivada
                                values={values}
                            />
                            */}
                        </GridItem3xs6>
                    :
                        <SimulacaoAporteTipoMomentoTributacaoIR
                            handleChange={handleChange}
                            report={report}
                            indAporte={indAporte}
                            item={item}
                            ind={ind}
                        />
                }
            </GridContainer>

            {popup && (
                <GridContainer>
                    <GridItem2/>
                    
                    <SimulacaoAporteTipoMomentoTributacaoIR
                        handleChange={handleChange}
                        report={report}
                        indAporte={indAporte}
                        item={item}
                        ind={ind}
                    />
                </GridContainer>
            )}
        </>
    )
}



const PrevidenciaPrivadaFormPrevidenciaPrivadaSimulacaoAporte = ({ values, handleChange, report, indAporte }) => {

    const isXsDownScreen = IsXsDownScreen()

    return (
        <FieldArray name={`objPrevidenciaPrivada.simulacao[${indAporte}].aporte`}>
            {(arrayHelpers) => (
                <DivForm>
                    <DivForm>
                        {values.objPrevidenciaPrivada.simulacao[indAporte].aporte?.map((item, ind) => {

                            return (
                                <div
                                    key={ind}
                                >
                                    <GridContainer>
                                        <GridItem1/>

                                        <GridItem3xs4>
                                            <TextValidatorValor
                                                name={`objPrevidenciaPrivada.simulacao[${indAporte}].aporte[${ind}].valorAporte`}
                                                label={LABEL.valorAporte}
                                                value={item.valorAporte || ''}
                                                onChange={handleChange}
                                                disabled={report}
                                                report={report}
                                            />
                                        </GridItem3xs4>

                                        <GridItem3xs5>
                                            <TextFieldTextSelect
                                                name={`objPrevidenciaPrivada.simulacao[${indAporte}].aporte[${ind}].tipoPeriodicidadeAporte`}
                                                label={LABEL.tipoPeriodicidadeAporte}
                                                value={item.tipoPeriodicidadeAporte || ''}
                                                onChange={handleChange}
                                                list={tipoPeriodicidadeList(false, true, true)}
                                                disabled={report}
                                                report={report}
                                            />
                                        </GridItem3xs5>

                                        {isXsDownScreen && (
                                            <GridItem1/>
                                        )}

                                        <GridItem2xs4>
                                            <TextValidatorMesAnoRequired
                                                name={`objPrevidenciaPrivada.simulacao[${indAporte}].aporte[${ind}].mesAnoInicialAporte`}
                                                label={LABEL.mesAnoInicial}
                                                value={item.mesAnoInicialAporte || ''}
                                                onChange={handleChange}
                                                disabled={report}
                                                report={report}
                                            />
                                        </GridItem2xs4>

                                        <GridItem2xs4>
                                            {item.tipoPeriodicidadeAporte !== HARDCODE.idTipoPeriodicidadeUnica && (
                                                <TextValidatorMesAnoRequired
                                                    name={`objPrevidenciaPrivada.simulacao[${indAporte}].aporte[${ind}].mesAnoFinalAporte`}
                                                    label={LABEL.mesAnoFinal}
                                                    value={item.mesAnoFinalAporte || ''}
                                                    onChange={handleChange}
                                                    disabled={report}
                                                    report={report}
                                                />
                                            )}
                                        </GridItem2xs4>

                                        {!report && (
                                            <GridItem1
                                                className={'mt-3'}
                                            >
                                                <GridContainer>
                                                    <GridItem6>
                                                        <CustomizedDialogsPopup
                                                            maxWidth="md"
                                                            popupTitle={LABEL.taxaJurosInflacao}
                                                            tooltipTitle={LABEL.expandir}
                                                            PopupButton={IconButtonMaisInformacoes}
                                                            popupButtonDestaque={false}
                                                            popupComponent={
                                                                <SimulacaoAporteTaxaTipoMomentoTributacaoIR
                                                                    values={values}
                                                                    handleChange={handleChange}
                                                                    report={report}
                                                                    indAporte={indAporte}
                                                                    item={item}
                                                                    ind={ind}
                                                                    popup={true}
                                                                />
                                                            }
                                                        />
                                                    </GridItem6>

                                                    <GridItem6>
                                                        <IconButtonClearEntradaDados
                                                            onClick={() =>
                                                                arrayHelpers.remove(ind)
                                                            }
                                                        />
                                                    </GridItem6>
                                                </GridContainer>
                                            </GridItem1>
                                        )}

                                        {(item.taxaJurosAnual || item.taxaJurosAnual === 0 || item.tipoMomentoTributacaoIR) && (
                                            <SimulacaoAporteTaxaTipoMomentoTributacaoIR
                                                values={values}
                                                handleChange={handleChange}
                                                report={report}
                                                indAporte={indAporte}
                                                item={item}
                                                ind={ind}
                                                popup={false}
                                            />
                                        )}
                                    </GridContainer>
                                </div>
                            )
                        })}
                    </DivForm>

                    {!report && (
                        <GridContainer>
                            <GridItem11>
                                <ButtonIncluirLinha
                                    align='right'
                                    label={LABEL.buttonIncluirAporte} 
                                    onClick={() =>
                                        arrayHelpers.push({
                                            tipoPeriodicidadeAporte: HARDCODE.idTipoPeriodicidadeMensal,
                                            mesAnoInicialAporte: formataDataEmMesAnoSemBarra(values.dataSimulacaoEstudo),
                                            mesAnoFinalAporte: '12' + values.anoFinalVaiAposentarCliente,
                                        })
                                    }
                                />
                            </GridItem11>
                        </GridContainer>
                    )}
                </DivForm>
            )}
        </FieldArray>
    )
}

export default PrevidenciaPrivadaFormPrevidenciaPrivadaSimulacaoAporte